class BracingDialogComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('configure-bracing-dialog', async () => this.configure(), true)
  }

  resetButton(id) {
    document.getElementById(id).classList.add('btn-default')
    document.getElementById(id).classList.remove('btn-primary')
  }

  configure() {
    document.getElementById('equal-bracing-form').classList.add('hidden')
    document.getElementById('custom-bracing-form').classList.add('hidden')

    this.resetButton('continuous-bracing-button')
    this.resetButton('equally-spaced-bracing-button')
    this.resetButton('custom-bracing-button')
    this.resetButton('unbraced-bracing-button')
    
    if(activeProject.design.bracingType === 'continuous') {
      document.getElementById('continuous-bracing-button').classList.add('btn-primary')  
    } else if (activeProject.design.bracingType === 'equal') {
      document.getElementById('equal-bracing-form').classList.remove('hidden')
      document.getElementById('equally-spaced-bracing-button').classList.add('btn-primary')  
      updateEquallySpacedBracingForm()
    } else if (activeProject.design.bracingType == 'custom') {
      document.getElementById('custom-bracing-form').classList.remove('hidden')
      document.getElementById('custom-bracing-button').classList.add('btn-primary')  
      updateCustomBracingTable();
    } else if (activeProject.design.bracingType == 'unbraced') {
      document.getElementById('unbraced-bracing-button').classList.add('btn-primary')  
    }
  }

  onBracingButtonClick(id) {

    let idMap = {
      'continuous-bracing-button': 'continuous',
      'equally-spaced-bracing-button': 'equal',
      'custom-bracing-button': 'custom',
      'unbraced-bracing-button': 'unbraced'
    }

    activeProject.beamController.updateBracingType(idMap[id])

    this.configure()

    RedrawCanvas()

    document.dispatchEvent(new CustomEvent('bracing-changed'))
  }

  connectedCallback() {

    this.innerHTML = String.raw`
    <div class="modal-body modal-body-shadow text-center" style="background:#F8F8F8">
      <button class="btn btn-primary button-shadow" id='continuous-bracing-button'>Continuous Bracing</button>
      <button class="btn btn-default button-shadow" id='equally-spaced-bracing-button'>Equally Spaced</button>
      <button class="btn btn-default button-shadow" id='custom-bracing-button'>Custom</button>
      <button class="btn btn-default button-shadow" id='unbraced-bracing-button'>Completely Unbraced</button>
    </div>

    <div class="modal-body">
      <form id="equal-bracing-form">
        <table class="table" id="equal-bracing-table">
          <tr class="success">
            <td style='width:100px;'>Spacing @:</td>
            <td><input style='width:100px;' id='equal-bracing-spacing-input' type='text'
                name='equal-bracing-spacing-input' value='0' onchange="onEqualSpacedBracingChange()"/>
              O.C.</td>
          </tr>
          <tr class="success">
            <td style='width:100px;'>Starting @:</td>
            <td><input style='width:100px;' id='equal-bracing-start-input' type='text'
                name='equal-bracing-start-input' value='0'  onchange="onEqualSpacedBracingChange()"/>
              from left end</td>
          </tr>
        </table>
      </form>
    
      <form id="custom-bracing-form" name="custom-bracing-form">
        <table class="table">
          <tr class="success">
            <td style="width:120px;">New Brace @:</td>
            <td><input style="width:100px;" id="new-brace-location-input" type="text"
                name="new-brace-location-input" value='0"' onchange="onNewBraceLocationChange()"></td>
            <td><button id="add-brace-button" type="button" class="btn btn-sm btn-success"
                onclick="addBrace()">Add</button>
            </td>
          </tr>
        </table>
        <div id="custom-bracing-table"></div>
      </form>
    </div>
    `

    document.getElementById('continuous-bracing-button').onclick = (() => this.onBracingButtonClick('continuous-bracing-button'))
    document.getElementById('equally-spaced-bracing-button').onclick = (() => this.onBracingButtonClick('equally-spaced-bracing-button'))
    document.getElementById('custom-bracing-button').onclick = (() => this.onBracingButtonClick('custom-bracing-button'))
    document.getElementById('unbraced-bracing-button').onclick = (() => this.onBracingButtonClick('unbraced-bracing-button'))

    this.configure()
  }
}

customElements.define('bracing-dialog-component', BracingDialogComponent)

function onEqualSpacedBracingChange() {
  let id = 'equal-bracing-spacing-input'
  if(validateRequiredInput(id) && validateLengthInput(id) && validateBraceSpacing(id)) {
  }
  id = 'equal-bracing-start-input'
  if(validateRequiredInput(id) && validateLengthInput(id) && validateBraceLocation(id)) {
  }
}

function onNewBraceLocationChange() {
  let id = 'new-brace-location-input'
  if(validateRequiredInput(id) && validateLengthInput(id) && validateBraceLocation(id)) {
  }
}

